@import 'vars';
@import 'mixins';

$spacing-s: 5px;
$spacing-m: 10px;
$empty-block-height: 35px;

.template-response-picker {
  padding: $spacing-m;
  width: 365px;
  max-height: 60vh;
  display: flex;
  flex-direction: column;

  &--softphone {
    max-height: unset;
    width: 100%;
  }

  &__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: $spacing-m;
  }

  &__templates {
    @include scrollable-container;
    flex: 1;
    margin-top: $spacing-m;
  }

  &__empty {
    color: $dark-grey;
    text-align: center;
    min-height: $empty-block-height;
    display: flex;
    align-items: center;
    justify-content: center;

    > * {
      color: $dark-grey;
    }
  }
}

.popover-menu-item__text__subtitle {
  max-height: 30px;
  text-wrap: normal;
}
